import { render, staticRenderFns } from "./VolatilitiesView.vue?vue&type=template&id=348e319c&scoped=true&"
import script from "./VolatilitiesView.vue?vue&type=script&lang=js&"
export * from "./VolatilitiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e319c",
  null
  
)

export default component.exports